import jsPDF from 'jspdf';

export const generatePDF = (workersData, monthYear) => {
  const doc = new jsPDF();
  const initialYOffset = 20;
  const lineSpacing = 6;
  let yOffset = initialYOffset;


  doc.text(`Gennemsnitlig rating for medarbejdere fra "MM/ÅÅÅÅ ${monthYear}`, 10, 10);
  
  workersData.forEach((worker, index) => {
    
    if (index > 0) {
      yOffset += lineSpacing * 2; 
    }
    doc.text(`Medarbejders navn: ${worker.name}`, 10, yOffset);
    
    worker.ratings.forEach((rating, ratingIndex) => {
      yOffset += lineSpacing;
      doc.text(`Gennemsnitlig Rating ${ratingIndex + 1}: ${rating.toFixed(2)}`, 15, yOffset);
    });
  });

  doc.save(`ratings-${monthYear}.pdf`);
};
